import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from './user';
import { environment } from 'src/environments/environment';
import {
  BehaviorSubject,
  map,
  of as observableOf,
  switchMap,
  take,
  tap,
} from 'rxjs';

@Injectable()
export class UserService {
  private _user = new BehaviorSubject<User | null>(null);
  readonly user$ = this._user.asObservable().pipe(
    switchMap((user) => {
      if (user) {
        return observableOf(user);
      } else {
        return this.getUserAndUpdate();
      }
    })
  );
  readonly permissions$ = this.user$.pipe(map(({ Permisos }) => Permisos));

  private readonly USER_KEY = 'Usuario';
  constructor(private httpClient: HttpClient) {
    const user = JSON.parse(localStorage.getItem(this.USER_KEY)) as User;
    this.getUserAndUpdate().subscribe();
    if (user) {
      this.user = user;
    } else {
    }
  }

  get user() {
    return this._user.value;
  }

  set user(user: User) {
    this._user.next(user);
    localStorage.setItem(this.USER_KEY, JSON.stringify(user));
  }

  getUserOnce() {
    return this.getUserAndUpdate();

    if (this.user) {
      return this.user$.pipe(take(1));
    } else {
      return this.getUserAndUpdate();
    }
  }

  getUserAndUpdate() {
    return this.httpClient
      .get<User>(`${environment.API_URL}/CoreUsuario/${localStorage.getItem('CodOrganizacion')}`)
      .pipe(tap((user) => (this.user = user)));
  }

  resetUser() {
    this.user = null;
  }
}
